import { Injectable } from '@angular/core';
import { TagDetail, TagSummary } from 'app/services/graphqlApi.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Property, PropertyType } from '../create-properties/interfaces/interfaces';
import { ComponentDetail } from '../interfaces/component';
import { IAssetInfo, IModelComponents, TagAlarm} from '../alarms/intefaces/intefaces';
// import { IModelComponents } from 'app/models/services/models.service';

@Injectable({
  providedIn: 'root'
})

export class DataService {
  compEditMode = new BehaviorSubject<boolean>(false);
  tagsEditMode = new BehaviorSubject<boolean>(false);
  editMode = new BehaviorSubject<boolean>(false);
  selectedTagIndex = new BehaviorSubject<number>(-1);
  tagDetails = new BehaviorSubject<TagDetail>(null);
  componentDetails = new BehaviorSubject<ComponentDetail>({} as ComponentDetail);
  propertyDetails = new BehaviorSubject<Property>({} as Property);
  modelComponents = new BehaviorSubject<IModelComponents[]>([]);

  readonly compEditMode$ = this.compEditMode.asObservable();
  readonly tagsEditMode$ = this.tagsEditMode.asObservable();
  readonly tagDetails$ = this.tagDetails.asObservable();
  readonly componentDetails$ = this.componentDetails.asObservable();
  readonly propertyDetails$ = this.propertyDetails.asObservable();
  readonly modelComponents$ = this.modelComponents.asObservable();

  readonly _properties = new BehaviorSubject<Property[]>([]);
  readonly properties$ = this._properties.asObservable();

  readonly tags = new BehaviorSubject<TagDetail[]>([]);
  readonly tags$ = this.tags.asObservable();

  readonly tagsSummary = new BehaviorSubject<TagSummary[]>([]);
  readonly tagsSummary$ = this.tagsSummary.asObservable();

  readonly selectedAlarm = new BehaviorSubject<TagAlarm|null>(null);
  readonly selectedAlarm$ = this.selectedAlarm.asObservable();

  readonly alarms = new BehaviorSubject<TagAlarm[]>([]);
  readonly alarms$ = this.alarms.asObservable();

  readonly assetInfo =  new BehaviorSubject<IAssetInfo|null>(null);
  readonly assetInfo$ = this.assetInfo.asObservable();

  readonly _deletedId =  new BehaviorSubject<string>('');
  readonly deletedId$ = this._deletedId.asObservable();

  readonly _isCalculatedAllowed =  new BehaviorSubject<boolean>(false);
  readonly isCalculatedAllowed$ = this._isCalculatedAllowed.asObservable();

  constructor() { }

  addNewAlarms(alarm: TagAlarm) {
    const alarms = this.alarms.getValue();
    this.alarms.next([...alarms, alarm]);
    const updatedTags = this.tags.getValue().map(t => {
      if(t.id === alarm.tagId) {
        t.alarmsCount += 1;
      }

      return t;
    });

    this.tags.next(updatedTags);
  }

  /**
   * asset basic info
   * @param info asset info
   */
  assetBasicInfo(info: IAssetInfo){
    this.assetInfo.next(info);
  }

  /**
   * update alarm
   * @param alarm alarm
   */
  updateAlarms(alarm: TagAlarm) {
    const alarms = this.alarms.getValue();
    const index = alarms.findIndex(a => !!a && a.id === alarm.id);
    if(index !== -1) {
      alarms[index] = alarm;
      this.alarms.next(alarms);
    }
  }

  /**
   * remove selected alarm
   * @param alarm alarm
   */
  removeSelectedAlarm(alarm: TagAlarm) {
    const alarms = this.alarms.getValue();
    const index = alarms.findIndex(a => !!a && a.id === alarm.id);
    if(index > -1) {
      alarms.splice(index, 1);
      this.alarms.next(alarms);
      const updatedTags: TagDetail[] = this.tags.getValue().map((tag: TagDetail) => {
        if(tag.id === alarm.tagId) {
          tag.alarmsCount -= 1;
        }

        return tag;
      });

      this.tags.next(updatedTags);
    }
  }

  setProperty(property: Property) {
    this.propertyDetails.next(property);
  }

  getEditMode() {
    return this.editMode.getValue();
  }

  setEditMode(editMode) {
    return this.editMode.next(editMode);
  }

  getComponentDetails() {
    return this.componentDetails.getValue();
  }

  setComponentDetails(component: ComponentDetail) {
    this.componentDetails.next(component);
  }

  getTagDetails() {
    return this.tagDetails.getValue();
  }

  setTagDetails(tag: TagDetail) {
    this.tagDetails.next(tag);
  }

  getCompEditMode() {
    return this.compEditMode.getValue();
  }

  setCompEditMode(mode: boolean) {
    this.compEditMode.next(mode);
  }

  getSelectedTagIndex() {
    return this.selectedTagIndex.getValue();
  }

  setSelectedTagIndex(mode: number) {
    this.selectedTagIndex.next(mode);
  }

  getTagsEditMode() {
    return this.tagsEditMode.getValue();
  }

  setTagsEditMode(mode: boolean) {
    this.tagsEditMode.next(mode);
  }

}
